<template>
  <el-dialog
    append-to-body
    width="500px"
    title="批量结清"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="true"
    :close-on-press-escape="false"
  >
    <el-form
      ref="elFormDom"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="账单日期:" prop="date">
            {{ multiRow.length }}天</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="账单金额:" prop="amount"
            >￥{{ form.data.amount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="已结金额:" prop="yet_settle_amount"
            >￥{{ form.data.yet_settle_amount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="未结金额:" prop="await_settle_amount"
            >￥{{ form.data.await_settle_amount }}</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="收款人:" prop="yet_settle_amount"
            >{{ currentRow.bank_account }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行:" prop="await_settle_amount"
            >{{ currentRow.bank_name }}</el-form-item
          >
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行卡号:" prop="yet_settle_amount"
            >{{ currentRow.bank_code }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联行号:" prop="await_settle_amount"
            >{{ currentRow.tax_code }}</el-form-item
          >
        </el-col>
        <el-col :span="24">
          <el-form-item label="结算金额:" prop="settleingAmount"
            >
            <span style="color:#F56C6C">{{ form.data.settleingAmount }}元</span>
            </el-form-item
          >
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件:" prop="image">
            <el-upload
              class="upload-demo"
              action="/api/common/qiniu/uploadFile"
              :limit="10"
              multiple
              :headers="{ token: token }"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :file-list="form.data.fileList"
              ref="uploadRef"
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls , .doc , .docx "
            >
              <el-button :size="subUnitSize" type="primary" plain
                >请上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="desc">
            <el-input style="width:80%" v-model="form.data.desc" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button :size="subUnitSize" type="primary" @click="conFirm"
          >确定提交</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
export default {
  props: {},
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      token: getStorage("token"),
      visible: false,
      form: {
        data: {
          amount: "",
          yet_settle_amount: "",
          await_settle_amount: "",
          settleingAmount: "",
          image:[],
          fileList: [],
          date:'',
          desc:'',
        },
        rules: {
          image: [
            // { required: true, message: "请上传", trigger: "change" },
          ],
        },
      },
      currentRow:{},
      multiRow:[],
    };
  },
  methods: {
    toggle(show) {
      this.visible = show;
      // !show && this.reset()
    },
    getDetail(rows,currentRow) {
      this.currentRow = currentRow;
      this.multiRow = rows;
      //账单金额
      let amount_ = rows.reduce((total, item) => {
        return total + (item.total_delivery_money*1000 + item.freight_amount*1000 - item.discount_amount*1000)/1000;
      }, 0);
      // 已结金额
      let settle_amount_ = rows.reduce((total, item) => {
        return (total*1000 + item.settle_amount*1000)/1000;
      }, 0);
      // 未结金额
      let yet_settle_amount = (amount_*1000 - settle_amount_*1000)/1000;
      console.log(yet_settle_amount,'yet_settle_amount')
      this.form.data.date = rows.map(item=>item.date).join('|');
      this.form.data.amount = Number(amount_).toFixed(2); //账单金额
      this.form.data.yet_settle_amount = Number(settle_amount_).toFixed(2); //已结金额
      this.form.data.await_settle_amount = Number(yet_settle_amount).toFixed(2); //未结金额
      this.form.data.settleingAmount = Number(yet_settle_amount).toFixed(2); //结算金额
    },
    // 图片上传成功
    handleAvatarSuccess(event,file, fileList) {
      // if (event.code == 1) {
      //   this.form.data.fileList = fileList.map((item) => {
      //     return {
      //       url: item.response.data.all_path_url || item.url,
      //       name: item.name,
      //     };
      //   });
      //   this.form.data.image = this.form.data.fileList
      //   this.$refs.elFormDom.clearValidate(['image']); // 清除 username 字段的校验状态，但不重置值
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: event.msg,
      //   });
      // }
    },
    // 移除图片
    handleRemove(file, fileList) {
      // this.form.data.fileList = fileList.map((item) => {
      //     return {
      //       url: item.response.data.all_path_url || item.url,
      //       name: item.name,
      //     };
      // });
      // this.form.data.image = this.form.data.fileList;
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.form.data.fileList = [];
      this.form.data.image = [];
      this.visible = false;
    },
    conFirm() {
      if(!this.currentRow.bank_account || !this.currentRow.bank_code ||
         !this.currentRow.bank_name || !this.currentRow.tax_code) {
          this.$message({
            type: "error",
            message: '收款人、开户银行、银行卡号、联行号存在未完善不能提交',
          });
          return 
      }
      let fileList_ = this.$refs.uploadRef.uploadFiles;
      this.form.data.image = fileList_.map((item) => {
        return {
          url:item.response?.data?.all_path_url || item.url,
          name:item.name
        }
      });
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let params = {
            supplier_id:this.currentRow.bind_id,
            date:this.form.data.date,
            amount:this.form.data.settleingAmount,
            file:this.form.data.image,
            is_part:2,
            desc:this.form.data.desc,
          };
          this.$http.post("/admin/bill/settle", params).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: '付款流程提交成功',
              });
              this.visible = false;
              this.reset();
              this.$emit("update");
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>